import React from 'react'
import styled from 'styled-components'
import {Button, Link} from 'startlibs/lib/components'
import {getColor} from 'startlibs/lib/lib'
import {ExpiredPageComponent, ContentBox} from './ExpiredShare'

const NotFoundPage = styled(ExpiredPageComponent)`
  ${ContentBox} {
    padding: 3.5rem 6rem;
    h2 {
      margin-bottom: 0;
      padding-bottom: 0;
    }
    .error-code {
      font-size: 11px;
      color: ${getColor('gray180')};
      margin-bottom: 1rem;
    }
  }
  @media (max-width: 440px) {
    ${ContentBox} {
      padding: 2rem 3rem;
    }
  }
`

export class PageNotFound extends React.PureComponent {

  render() {
    return <NotFoundPage>
      <div className="navbar">
        <Link to="/" className="logo">Horos Cloud</Link>
      </div>
      <ContentBox topImage>
        <img src="/public/404-icon.png" alt="Expired" />
        <h2>Oops! Something is not right...</h2>
        <div className="error-code">Error status: 404 - Not found</div>
        <p>We can’t find the page you’re looking for, it is possible that it does not exist or has been removed.</p>
        <p>Consider double-checking that the link is correct, or follow one of the links below to get back on track.</p>
        <Button.Link highlight skipTo="/">Go to Horos Cloud home</Button.Link>
      </ContentBox>
      <div className="useful-links">
        <div>Here are some other useful links</div>
          <a className="link" href="https://horosproject.org">Horos Project website</a>
          <a className="link" href="https://horosproject.org/download-horos/">Download Horos</a>
          <Link className="link" skipTo="/signUp">Sign up to Horos Cloud</Link>
      </div>
    </NotFoundPage>
  }

}



// WEBPACK FOOTER //
// ./src/javascripts/public/PageNotFound.jsx